import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import styles from "../../styles/components/memberPartner-dashboard-table.module.scss";
import EyeTableIcon from "../../public/assets/icons/EyeTableIcon";
import { Box, Button, Tooltip, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import ApiLoader from "../Loaders/ApiLoader";
import { getStyledDateTime } from "../../lib/functions/utils.lib";
import { html2pdf } from "html2pdf.js";

/****************table*****************/
function createData(vsid, Sender, Message, Creation) {
  return { vsid, Sender, Message, Creation };
}

const WrapText = (text, span) => {
  return (
    <>
      {text}
      <Typography variant="caption">{span}</Typography>
    </>
  );
};

const rows = [
  createData(
    "13194",
    WrapText("Jason Marcel", "Manager"),
    "Hi there, how are you doing? I was trying to reest my password but it kept showing me an error message and I am not su...",
    WrapText("January 16, 2023", "at 07:53 AM UTC ")
  ),
  createData(
    "13194",
    WrapText("John Smith", "QC Agent"),
    "I am curious on when I’ll be paid? Could you please let me know? Thanks in advance!",
    WrapText("January 14, 2023", "at 10:22 PM UTC ")
  ),
  createData(
    "13194",
    WrapText("ViralSnare Admin", "Admin"),
    "Hey, i wanted to message you to let you know that we got the original file and I have added it to the submission. Thanks!",
    WrapText("January 01, 2023", "at 07:22 PM UTC ")
  ),
  createData(
    "13194",
    WrapText("Jason Marcel", "Manager"),
    "Hi there, how are you doing? I was trying to reest my password but it kept showing me an error message and I am not su...",
    WrapText("January 16, 2023", "at 07:53 AM UTC ")
  ),
  createData(
    "13194",
    WrapText("John Smith", "QC Agent"),
    "Hey, i wanted to message you to let you know that we got the original file and I have added it to the submission. Thanks!",
    WrapText("January 14, 2023", "at 10:22 PM UTC ")
  ),
  createData(
    "13194",
    WrapText("ViralSnare Admin", "Admin"),
    "Let’s confirm the shooter of this video",
    WrapText("January 01, 2023", "at 07:22 PM UTC ")
  ),
  createData(
    "13194",
    WrapText("Jason Marcel", "Manager"),
    "Hey, i wanted to message you to let you know that we got the original file and I have added it to the submission. Thanks!",
    WrapText("January 14, 2023", "at 10:22 PM UTC ")
  ),
  createData(
    "13194",
    WrapText("John Smith", "QC Agent"),
    "Let’s confirm the shooter of this video",
    WrapText("January 01, 2023", "at 07:22 PM UTC ")
  ),
  createData(
    "13194",
    WrapText("Jason Marcel", "Manager"),
    "Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away",
    WrapText("January 16, 2023", "at 07:53 AM UTC ")
  ),
  createData(
    "13194",
    WrapText("John Smith", "QC Agent"),
    "Hey, i wanted to message you to let you know that we got the original file and I have added it to the submission. Thanks!",
    WrapText("January 14, 2023", "at 07:53 AM UTC ")
  ),
  createData(
    "13194",
    WrapText("ViralSnare Admin", "Admin"),
    "Let’s confirm the shooter of this video",
    WrapText("January 01, 2023", "at 07:53 AM UTC ")
  ),
  createData(
    "13194",
    WrapText("Jason Marcel", "Manager"),
    "Hey, i wanted to message you to let you know that we got the original file and I have added it to the submission. Thanks!",
    WrapText("January 14, 2023", "at 07:53 AM UTC ")
  ),
  createData(
    "13194",
    WrapText("John Smith", "QC Agent"),
    "Let’s confirm the shooter of this video",
    WrapText("January 01, 2023", "at 07:53 AM UTC ")
  ),
  createData(
    "13194",
    WrapText("Jason Marcel", "Manager"),
    "Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away",
    WrapText("January 16, 2023", "at 07:53 AM UTC ")
  ),
];

const MemberPartnerDashBoardTable = ({ message, isLoading }) => {
  console.warn("messageData", message);
  {
    message?.map((item) => {
      console.warn("idHere", item?.id);
    });
  }
  return (
    <TableContainer className={styles.tableMain}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell className={styles.vsid}>VSID</TableCell>
            <TableCell className={styles.sender}>Sender</TableCell>
            <TableCell className={styles.message}>Message</TableCell>
            <TableCell className={styles.creation}>Creation Date</TableCell>
            <TableCell className={styles.view} align="center">
              View
            </TableCell>
          </TableRow>
        </TableHead>
        {isLoading ? (
          <ApiLoader loading={isLoading} />
        ) : (
          <TableBody>
            {message?.length ? (
              message?.map((item, index) => (
                <>
                  <TableRow key={index}>
                    <TableCell>
                      <Link to="">
                        <Tooltip
                          title="Open video page"
                          placement="bottom-start"
                          className="memberPartnerTooltip"
                        >
                          {item?.video?.id}
                        </Tooltip>
                      </Link>
                    </TableCell>
                    <TableCell>
                      <Box className={styles.senderBox}>
                        {item.initiated?.name ? item?.initiated?.name : "_"}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box className={styles.messageBox}>
                        {item.message ? item?.message : ""}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box className={styles.creationBox}>
                        {getStyledDateTime(item.created ? item?.created : "")}
                      </Box>
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip
                        title="Open Message"
                        placement="bottom-start"
                        className="memberPartnerTooltip"
                      >
                        <Button>
                          <Link
                            to={`/member-partner-dashboard/message/video/${item?.id}`}
                          >
                            {" "}
                            <EyeTableIcon />
                          </Link>
                        </Button>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={styles.blanktd}></TableCell>
                    <TableCell className={styles.blanktd}></TableCell>
                    <TableCell className={styles.blanktd}></TableCell>
                    <TableCell className={styles.blanktd}></TableCell>
                    <TableCell className={styles.blanktd}></TableCell>
                  </TableRow>
                </>
              ))
            ) : (
              <h2>You have no open messages at the moment</h2>
            )}
          </TableBody>
        )}
      </Table>
    </TableContainer>
  );
};

export default MemberPartnerDashBoardTable;
